import { getClosedDates } from '@/api/dates/getClosedDates.ts';
import { getDateFromTenor } from '@/api/dates/getDateFromTenor.ts';
import { webapi } from '@/api/webapi.ts';

export const datesApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    closedDates: getClosedDates(builder),
    dateFromTenor: getDateFromTenor(builder),
  }),
});

export const { useClosedDatesQuery, useDateFromTenorQuery } = datesApi;
export const { initiate: initiateDateFromTenor } = datesApi.endpoints.dateFromTenor;
